<template>
  <header class="pp-hero">
    <div class="pp-page__container">
      <div class="pp-hero__card">
        <div class="pp-hero__shell">
          <div class="pp-hero__media">
            <button
              v-if="visume"
              type="button"
              class="pp-hero__avatar-btn"
              aria-label="Watch visume"
              @click="$emit('open-visume')"
            >
              <video :key="visumePath" preload="metadata" muted playsinline>
                <source :src="visumeUrl" type="video/mp4" />
              </video>
              <span class="pp-hero__play" aria-hidden="true">
                <span class="pp-hero__play-icon">
                  <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
                    <path fill="currentColor" d="M8 5v14l11-7z" />
                  </svg>
                </span>
              </span>
              <span class="pp-hero__visume-badge" aria-hidden="true">Visume</span>
            </button>
            <div v-else class="pp-hero__avatar-btn pp-hero__avatar-placeholder" :aria-label="`${user.name} avatar`">
              <span class="pp-hero__initials">{{ initials }}</span>
            </div>
          </div>

          <div class="pp-hero__body">
            <div class="pp-hero__info">
              <h1 class="pp-hero__name">{{ user.name }}</h1>
              <p v-if="headline" class="pp-hero__headline">{{ headline }}</p>
              <p v-else-if="openToLine" class="pp-hero__headline pp-hero__headline--muted">{{ openToLine }}</p>
            </div>

            <p v-if="hasContact" class="pp-hero__contact-line">
              <a
                v-if="user.email"
                class="pp-hero__contact-link"
                :href="`mailto:${user.email}`"
              >{{ user.email }}</a>
              <span v-if="user.email && user.mobile" class="pp-hero__dot" aria-hidden="true">·</span>
              <a
                v-if="user.mobile"
                class="pp-hero__contact-link"
                :href="`tel:${user.mobile}`"
              >{{ user.mobile }}</a>
            </p>

            <p v-if="metaChips.length" class="pp-hero__meta-line">
              <span
                v-for="(chip, index) in metaChips"
                :key="chip.key"
                class="pp-hero__meta-item"
              >
                <span v-if="index > 0" class="pp-hero__dot" aria-hidden="true">·</span><span
                  class="pp-hero__meta-part"
                  :class="chipChipClass(chip.key)"
                >{{ chip.text }}</span>
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'PublicProfileHero',
  props: {
    user: { type: Object, required: true },
    headline: { type: String, default: '' },
    jobRoles: { type: Array, default: () => [] },
    initials: { type: String, default: '?' },
    locationLabel: { type: String, default: '' },
    experienceLabel: { type: String, default: '' },
    educationLabel: { type: String, default: '' },
    visume: { type: String, default: '' },
    visumePath: { type: String, default: '' },
    showEducationSection: { type: Boolean, default: false },
    showExperienceSection: { type: Boolean, default: false },
  },
  computed: {
    visumeUrl() {
      return this.visumePath ? this.$S3_bucket_url + this.visumePath : '';
    },
    openToLine() {
      if (this.headline || !this.jobRoles.length) return '';
      const roles = this.jobRoles.slice(0, 2).join(' · ');
      return `Open to ${roles}`;
    },
    hasContact() {
      return !!(this.user?.email || this.user?.mobile);
    },
    metaChips() {
      const chips = [];
      if (this.locationLabel) {
        chips.push({ key: 'location', text: this.locationLabel });
      }
      if (this.experienceLabel) {
        chips.push({ key: 'exp', text: this.experienceLabel });
      }
      if (this.educationLabel) {
        chips.push({ key: 'edu', text: this.educationLabel });
      }
      return chips;
    },
  },
  methods: {
    chipChipClass(key) {
      if (key === 'edu' && this.showEducationSection) return 'pp-hero__meta-part--desktop-only';
      if (key === 'exp' && this.showExperienceSection) return 'pp-hero__meta-part--desktop-only';
      return null;
    },
  },
};
</script>
